import { Component, input } from '@angular/core';

import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'boels-order-entry-accessory-label',
  imports: [TranslocoModule],
  templateUrl: './order-entry-accessory-label.component.html',
  styleUrl: './order-entry-accessory-label.component.scss',
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'addToCart',
    },
  ],
})
export class OrderEntryAccessoryLabelComponent {
  variant = input.required<'mandatory'>();
}
